import angular from 'angular';
import ManageContactComponent from './manage-contact-component';

export default angular.module('manage-contact', []).component('manageContact', new ManageContactComponent());



// WEBPACK FOOTER //
// ./src/modules/contact/components/manage-contact/manage-contact-module.js